module.exports = __webpack_public_path__ + "static/media/slower.9a02d74a.svg";